import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import LoadingProgressBar from "../../spinners/LoadingProgressBar";
import AlertNoPermission from "../../alerts/AlertNoPermission";
import $ from "jquery";

class PaymentTypeGroupsDropdown extends Component {
    state = { loading: true, noPermission: false, paymentGroups: null };

    getPaymentTypes = async () => {
        const { fetchURL, onShowAlert, activeEvent, defaultValue, t } = this.props;
        const passData = { activeEvent: activeEvent, selectedParts: defaultValue ? defaultValue : null };
        try {
            const response = await fetch(`${fetchURL}/payment-type-groups`, {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(passData),
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: t(`error.${fetchedData.code}`) });
                    else {
                        const paymentTypes = fetchedData.list;
                        let paymentGroups = [];
                        paymentTypes.forEach((e, i) => {
                            paymentGroups.push({
                                key: i + 1,
                                value: e.payment_type_group,
                                text: t(`payment.groups.${e.payment_type_group}`),
                            });
                        });
                        paymentGroups.unshift({ key: 0, value: "all", text: t("selectAll") });

                        this.setState({ paymentGroups: paymentGroups, loading: false });
                    }
                });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        this.getPaymentTypes();
    }

    render() {
        const { noPermission, loading, paymentGroups } = this.state;
        const { t, selectedPaymentGroup, onSelectPaymentGroup } = this.props;
        return (
            <Fragment>
                <Form.Label className="w-100">{t("payment.list.group")}</Form.Label>
                {noPermission ? (
                    <AlertNoPermission t={t} />
                ) : paymentGroups && !loading ? (
                    <Dropdown
                        value={selectedPaymentGroup}
                        id="paymentTypeGroups"
                        className="req mb-3"
                        placeholder={t("select")}
                        fluid
                        selection
                        options={paymentGroups}
                        onChange={(event, { value }) => {
                            $("#paymentTypeGroups").removeClass("danger");
                            onSelectPaymentGroup(value);
                        }}
                    />
                ) : (
                    <LoadingProgressBar t={t} />
                )}
            </Fragment>
        );
    }
}

export default PaymentTypeGroupsDropdown;
